import { useState, useEffect, useCallback } from 'react';
import { getDueReviews } from '@services/repService';

/**
 * Prompt 4 Part B4: what's due for review right now. Never gates
 * progression on the main path — this is purely a visible, optional
 * surface (a count badge, an openable queue), never a blocking modal.
 */
export const useDueReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    setLoading(true);
    return getDueReviews()
      .then(({ reviews: data }) => setReviews(data ?? []))
      .catch(() => setReviews([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { reviews, count: reviews.length, loading, refresh };
};

export default useDueReviews;
